<template>
  <div
    id="container"
    :class="[schoolLevelContainerClass, route.meta?.containerClass]"
    class="items-stretch flex flex-col flex-grow h-screen min-h-screen bg-cover"
  >
    <div
      v-if="containerLoaded"
      id="canvas"
      class="relative self-stretch flex bg-white bg-opacity-30 grow mt-[47px] mx-[47px]"
    >
      <nav
        id="school-level-navigation"
        class="absolute left-[-150px] top-[160px] -rotate-90 z-10"
      >
        <router-view name="schoolLevelNavigation" v-slot="{ Component }">
          <transition-fade :duration="500" appear>
            <component :is="Component" />
          </transition-fade>
        </router-view>
      </nav>

      <nav
        id="section-navigation"
        class="absolute left-[-20px] top-[-20px] z-10"
      >
        <router-view name="sectionNavigation" />
      </nav>

      <router-view name="header" v-slot="{ Component }">
        <component v-if="Component" :is="Component" />
      </router-view>

      <router-view name="content" v-slot="{ Component }">
        <component :is="Component" id="content" />
      </router-view>

      <aside
        id="sideways-logo"
        class="flex flex-col h-full justify-around absolute top-0 right-[-18px] z-10"
      >
        <span
          title="#TREFWOORD"
          class="bg-[url('../../assets/images/common/trefwoord-logo.png')] bg-center bg-contain bg-no-repeat inline-block h-[110px] indent-[-8192px] w-[56px]"
        ></span>
      </aside>
    </div>

    <intro-popup />

    <transition-fade :duration="300" appear>
      <div
        v-if="loading"
        class="box-content flex justify-center items-center w-screen h-screen text-almostBlack font-sans antialiased"
      >
        <box-generic header="Laden...">
          Even geduld; de inhoud van het digibord wordt geladen.
        </box-generic>
      </div>
    </transition-fade>

    <footer
      id="footer"
      class="flex shrink-0 justify-center items-center text-xs"
    >
      <div>
        Trefwoord is een uitgave van Kwintessens, &copy;{{
          new Date().getFullYear()
        }}
      </div>
      <ul v-html="footerMenu" />
    </footer>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import { RouterView } from "vue-router";

import router from "./router";

import BoxGeneric from "./components/content/BoxGeneric.vue";
import IntroPopup from "./components/app/IntroPopup.vue";
import TransitionFade from "./components/magic/TransitionFade.vue";

export default {
  name: "App",
  components: {
    BoxGeneric,
    IntroPopup,
    RouterView,
    // RouterLink,
    TransitionFade,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState(["container", "route"]),
    ...mapGetters(["containerLoaded", "routedSchoolLevel"]),
    schoolLevelContainerClass() {
      return `school-level-${this.routedSchoolLevel?.slug || "none"}`;
    },
    footerMenu() {
      return document.getElementById("footerMenu").innerHTML;
    },
  },
  async created() {
    // Fetch the container in a global beforeEach router guard:
    // This guard is called after Sentry's (setting up the transaction
    // from the `sentry-trace` meta tag), but before components'
    // `beforeRouteEnter` guards, which *wait* for the container to
    // have finished loading before they can reason about route params.
    router.beforeEach(async (to, from) => {
      if (!this.containerLoaded && !this.loading) {
        this.loading = true;
        await this.fetchContainer();
        this.loading = false;
      }
    });
  },
  methods: {
    ...mapActions(["fetchContainer"]),
  },
};
</script>
